import React from "react";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";
import HomeIcon from "@mui/icons-material/Home";
import MarketingIcon from "@mui/icons-material/TrendingUp";
import FunnelIcon from "@mui/icons-material/FilterList";
import ScheduleIcon from "@mui/icons-material/Schedule";
import MailIcon from "@mui/icons-material/Mail";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PeopleIcon from "@mui/icons-material/People";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import BusinessIcon from "@mui/icons-material/Business";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AddTaskIcon from "@mui/icons-material/AddTask";
import ListAltIcon from "@mui/icons-material/ListAlt";
// Import new icons
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import EqualizerIcon from "@mui/icons-material/Equalizer";
// Add this to your imports
import EventBusyIcon from "@mui/icons-material/EventBusy";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

const MenuList = ({ roleId, gradeCode, isDarkTheme, handleMenuItemClick }) => {
  // Check if user is authenticated
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  
  // If not authenticated, return empty List
  if (!isAuthenticated) {
    return <List></List>;
  }

  return (
    <List>
      {/* Common Menu for All Roles */}
      {/* Task Dashboard renamed to Task Overview with better icon */}
      <ListItem
        button
        onClick={() => handleMenuItemClick("/task-dashboard")}
        sx={{
          borderRadius: "8px",
          margin: "4px 16px",
          "&:hover": {
            backgroundColor: isDarkTheme
              ? "rgba(255,255,255,0.1)"
              : "rgba(0,0,0,0.04)",
            transform: "translateX(4px)",
          },
          transition: "all 0.3s ease",
        }}
      >
        <ListItemIcon>
          <EqualizerIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
        </ListItemIcon>
        <ListItemText primary="Task Overview" />
      </ListItem>

      {/* My Tasks renamed to My Daily Tasks with better icon */}
      <ListItem
        button
        onClick={() => handleMenuItemClick("/my-tasks")}
        sx={{
          borderRadius: "8px",
          margin: "4px 16px",
          "&:hover": {
            backgroundColor: isDarkTheme
              ? "rgba(255,255,255,0.1)"
              : "rgba(0,0,0,0.04)",
            transform: "translateX(4px)",
          },
          transition: "all 0.3s ease",
        }}
      >
        <ListItemIcon>
          <FormatListBulletedIcon
            sx={{ color: isDarkTheme ? "#fff" : "#000" }}
          />
        </ListItemIcon>
        <ListItemText primary="My Daily Tasks" />
      </ListItem>

      {/* Add Task Menu for Specific Grades (G3 to G10) */}
      {(gradeCode === "G3" ||
        gradeCode === "G4" ||
        gradeCode === "G5" ||
        gradeCode === "G6" ||
        gradeCode === "G7" ||
        gradeCode === "G8" ||
        gradeCode === "G9" ||
        gradeCode === "G10") && (
        <ListItem
          button
          onClick={() => handleMenuItemClick("/add-task")}
          sx={{
            borderRadius: "8px",
            margin: "4px 16px",
            "&:hover": {
              backgroundColor: isDarkTheme
                ? "rgba(255,255,255,0.1)"
                : "rgba(0,0,0,0.04)",
              transform: "translateX(4px)",
            },
            transition: "all 0.3s ease",
          }}
        >
          <ListItemIcon>
            <AddTaskIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
          </ListItemIcon>
          <ListItemText primary="Create New Task" />
        </ListItem>
      )}

      {/* People Menu - for Chairman and HR roles with specific grades */}
      {(roleId === "U-GROUP-001" || 
        (roleId === "U-HR-ROLE-001" && 
         (gradeCode === "G6" || 
          gradeCode === "G7" || 
          gradeCode === "G8" || 
          gradeCode === "G9" || 
          gradeCode === "G10"))) && (
        <ListItem
          button
          onClick={() => handleMenuItemClick("/people")}
          sx={{
            borderRadius: "8px",
            margin: "4px 16px",
            "&:hover": {
              backgroundColor: isDarkTheme
                ? "rgba(255,255,255,0.1)"
                : "rgba(0,0,0,0.04)",
              transform: "translateX(4px)",
            },
            transition: "all 0.3s ease",
          }}
        >
          <ListItemIcon>
            <PeopleIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
          </ListItemIcon>
          <ListItemText primary="People" />
        </ListItem>
      )}

      {/* Create People Menu - for Chairman and HR roles with specific grades */}
      {(roleId === "U-GROUP-001" || 
        (roleId === "U-HR-ROLE-001" && 
         (gradeCode === "G6" || 
          gradeCode === "G7" || 
          gradeCode === "G8" || 
          gradeCode === "G9" || 
          gradeCode === "G10"))) && (
        <ListItem
          button
          onClick={() => handleMenuItemClick("/create-people")}
          sx={{
            borderRadius: "8px",
            margin: "4px 16px",
            "&:hover": {
              backgroundColor: isDarkTheme
                ? "rgba(255,255,255,0.1)"
                : "rgba(0,0,0,0.04)",
              transform: "translateX(4px)",
            },
            transition: "all 0.3s ease",
          }}
        >
          <ListItemIcon>
            <PersonAddIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
          </ListItemIcon>
          <ListItemText primary="Create People" />
        </ListItem>
      )}

      {/* Leave menu with more appropriate icon */}
      <ListItem
        button
        onClick={() => handleMenuItemClick("/my-leave")}
        sx={{
          borderRadius: "8px",
          margin: "4px 16px",
          "&:hover": {
            backgroundColor: isDarkTheme
              ? "rgba(255,255,255,0.1)"
              : "rgba(0,0,0,0.04)",
            transform: "translateX(4px)",
          },
          transition: "all 0.3s ease",
        }}
      >
        <ListItemIcon>
          <EventBusyIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
        </ListItemIcon>
        <ListItemText primary="Leave" />
      </ListItem>

      {/* Role-Specific Menus */}
      {roleId === "Creator" && (
        <ListItem
          button
          onClick={() => handleMenuItemClick("/home")}
          sx={{
            borderRadius: "8px",
            margin: "4px 16px",
            "&:hover": {
              backgroundColor: isDarkTheme
                ? "rgba(255,255,255,0.1)"
                : "rgba(0,0,0,0.04)",
              transform: "translateX(4px)",
            },
            transition: "all 0.3s ease",
          }}
        >
          <ListItemIcon>
            <CodeIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
          </ListItemIcon>
          <ListItemText primary="Add Post Code" />
        </ListItem>
      )}

      {/* Show All Menus for CPO */}
      {roleId === "OL-PT-ROLE-001" && (
        <>
          <ListItem
            button
            onClick={() => handleMenuItemClick("/cpo-dashboard")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <HomeIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Home" />
          </ListItem>
          <ListItem
            button
            onClick={() => handleMenuItemClick("/digi-marketing")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <MarketingIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Digi Marketing" />
          </ListItem>
          <ListItem
            button
            onClick={() => handleMenuItemClick("/sales-funnel")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <FunnelIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Sales Funnel" />
          </ListItem>
        </>
      )}

      {/* Show Only Home Menu for Product Manager */}
      {roleId === "OL-PT-ROLE-002" && (
        <ListItem
          button
          onClick={() => handleMenuItemClick("/product-manager-dashboard")}
          sx={{
            borderRadius: "8px",
            margin: "4px 16px",
            "&:hover": {
              backgroundColor: isDarkTheme
                ? "rgba(255,255,255,0.1)"
                : "rgba(0,0,0,0.04)",
              transform: "translateX(4px)",
            },
            transition: "all 0.3s ease",
          }}
        >
          <ListItemIcon>
            <HomeIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </ListItem>
      )}

      {/* Show Only Home Menu for Associate Product Manager */}
      {roleId === "OL-PT-ROLE-003" && (
        <ListItem
          button
          onClick={() =>
            handleMenuItemClick("/associate-product-manager-dashboard")
          }
          sx={{
            borderRadius: "8px",
            margin: "4px 16px",
            "&:hover": {
              backgroundColor: isDarkTheme
                ? "rgba(255,255,255,0.1)"
                : "rgba(0,0,0,0.04)",
              transform: "translateX(4px)",
            },
            transition: "all 0.3s ease",
          }}
        >
          <ListItemIcon>
            <HomeIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </ListItem>
      )}

      {/* Show Only Home Menu for Junior Product Manager */}
      {roleId === "OL-PT-ROLE-004" && (
        <ListItem
          button
          onClick={() =>
            handleMenuItemClick("/junior-product-manager-dashboard")
          }
          sx={{
            borderRadius: "8px",
            margin: "4px 16px",
            "&:hover": {
              backgroundColor: isDarkTheme
                ? "rgba(255,255,255,0.1)"
                : "rgba(0,0,0,0.04)",
              transform: "translateX(4px)",
            },
            transition: "all 0.3s ease",
          }}
        >
          <ListItemIcon>
            <HomeIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </ListItem>
      )}

      {/* Show Only Home Menu for "Product Intern / Trainee	" */}
      {roleId === "OL-PT-ROLE-005" && (
        <ListItem
          button
          onClick={() => handleMenuItemClick("/product-intern-dashboard")}
          sx={{
            borderRadius: "8px",
            margin: "4px 16px",
            "&:hover": {
              backgroundColor: isDarkTheme
                ? "rgba(255,255,255,0.1)"
                : "rgba(0,0,0,0.04)",
              transform: "translateX(4px)",
            },
            transition: "all 0.3s ease",
          }}
        >
          <ListItemIcon>
            <HomeIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </ListItem>
      )}

      {/* Show Navigation for Social Media Executive */}
      {roleId === "OL-MG-ROLE-004" && (
        <>
          {/* Home Navigation */}
          <ListItem
            button
            onClick={() => handleMenuItemClick("/social-media-dashboard")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <HomeIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Home" />
          </ListItem>

          {/* Content Scheduler */}
          <ListItem
            button
            onClick={() => handleMenuItemClick("/content-scheduler")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <ScheduleIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Content Scheduler" />
          </ListItem>

          {/* Inbox Manager */}
          <ListItem
            button
            onClick={() => handleMenuItemClick("/inbox-manager")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <MailIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Inbox Manager" />
          </ListItem>

          {/* Engagement Tracker */}
          <ListItem
            button
            onClick={() => handleMenuItemClick("/engagement-tracker")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <TrendingUpIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Engagement Tracker" />
          </ListItem>

          {/* Trend Watch */}
          <ListItem
            button
            onClick={() => handleMenuItemClick("/trend-watch")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <VisibilityIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Trend Watch" />
          </ListItem>

          {/* Collab & Influencer */}
          <ListItem
            button
            onClick={() => handleMenuItemClick("/collab-influencer")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <PeopleIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Collab & Influencer" />
          </ListItem>

          {/* My Workspace */}
          <ListItem
            button
            onClick={() => handleMenuItemClick("/my-workspace")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <WorkspacesIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="My Workspace" />
          </ListItem>
        </>
      )}

      {/* Show Navigation for Chairman */}
      {roleId === "U-GROUP-001" && (
        <>
          {/* Home Navigation */}
          <ListItem
            button
            onClick={() => handleMenuItemClick("/umbrella-view")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <DashboardIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Umbrella View" />
          </ListItem>

          <ListItem
            button
            onClick={() => handleMenuItemClick("/company-overview")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <BusinessIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Company Overview" />
          </ListItem>

          <ListItem
            button
            onClick={() => handleMenuItemClick("/all-tasks")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <ListAltIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="All Tasks" />
          </ListItem>
        </>
      )}

      {/* Show Navigation for HR Role with specific grades */}
      {(roleId === "U-HR-ROLE-001" && 
       (gradeCode === "G6" || 
        gradeCode === "G7" || 
        gradeCode === "G8" || 
        gradeCode === "G9" || 
        gradeCode === "G10")) && (
        <>
          <ListItem
            button
            onClick={() => handleMenuItemClick("/people")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <PeopleIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="People" />
          </ListItem>

          <ListItem
            button
            onClick={() => handleMenuItemClick("/create-people")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <PersonAddIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Create People" />
          </ListItem>
        </>
      )}

    </List>
  );
};

export default MenuList;
